<template>
  <div>
    <!-- <el-upload  
      action="https://jsonplaceholder.typicode.com/posts/"
      :limit="3"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      :on-success="handleSuccess"
      accept=".doc,.docx,.png"
      :file-list="fileData"
      :http-request="uploadFileApi"
      :show-file-list="true"
      multiple
      ref="uploadRef"
      class="uploadFile"
      style="display: none;"
      >
      <div slot="tip" class="el-upload__tip" style="margin-top:0px">已选择附件：</div>
      <i class="el-icon-plus"></i>
    </el-upload> -->

    <quill-editor
      ref="myQuillEditor"
      v-model="content"
      :options="editorOption"
      class="editor"
      @blur="onEditorBlur($event)"
      @focus="onEditorFocus($event)"
      @change="onEditorChange($event)"
    >
      <span class="ql-formats">
        <button
          type="button"
          class="ql-upload"
          style="display: none !important;"
        >
          <svg viewBox="0 0 18 18">
            <rect class="ql-stroke" height="10" width="12" x="3" y="4"></rect>
            <circle class="ql-fill" cx="6" cy="7" r="1"></circle>
            <polyline
              class="ql-even ql-fill"
              points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
            ></polyline>
          </svg>
        </button>
      </span>
    </quill-editor>
    <div
      v-if="pageSource == 'postingAdd'"
      v-loading.fullscreen.lock="uploadLoading"
    >
      <el-upload
        class="upload-demo"
        :data="uploadData"
        :action="uploadForm.action"
        :headers="uploadForm.headers"
        :before-upload="beforeAvatarUpload"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :on-progress="onProgress"
        :on-remove="handleRemove"
        :on-preview="handlePreview"
        multiple
        :file-list="fileData"
      >
        <!-- :limit="3" -->
        <el-button
          size="small"
          type="primary"
          @click="uploadBtn"
          class="my-upload"
          v-show="false"
          style="height:0px"
          :disabled="pageSource == 'themeDetails'"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip" style="margin-top:0px">
          附件（{{ fileData.length }}）
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import { selectForumTheme } from "@/app/shop/api/shopping";
import * as Quill from "quill"; //引入编辑器
import { addQuillTitle } from "./quill-title.js";
import { addUrlPerFix } from "@/basa/utils";
import { getArgs } from "@/basa/utils";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Cookies from "js-cookie";
// 自定义字体
let fontFamily = ["宋体", "黑体", "微软雅黑", "楷体", "仿宋", "Arial", "苹方"];
Quill.imports["attributors/style/font"].whitelist = fontFamily;
Quill.register(Quill.imports["attributors/style/font"]);

// 自定义文字大小
let fontSize = ["10px", "12px", "14px", "16px", "20px", "24px", "36px"];
Quill.imports["attributors/style/size"].whitelist = fontSize;
Quill.register(Quill.imports["attributors/style/size"]);
// 自定义文件上传
let Link = Quill.import("formats/link");
class FileBlot extends Link {
  // 继承Link Blot
  static create(value) {
    let node = undefined;
    if (value && !value.href) {
      // 适应原本的Link Blot
      node = super.create(value);
    } else {
      // 自定义Link Blot
      node = super.create(value.href);
      // node.setAttribute('download', value.innerText);  // 左键点击即下载
      node.innerText = value.innerText;
      node.download = value.innerText;
    }
    return node;
  }
}
FileBlot.blotName = "link";
FileBlot.tagName = "A";
Quill.register(FileBlot);

const toolbarOptions1 = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}], // 文本方向
  [{ size: fontSize }], // 文字大小
  [{ font: fontFamily }], // 字体
  // [{ size: ["small", false, "large", "huge"] }],
  // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }], // 字体颜色、
  [{ background: [] }], // 字体背景颜色
  // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  // ['link',"image",'upload'], // 链接、图片、视频
  ["upload"],
  // // ['link']
  ["sourceEditor"] //附件
];
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  ["blockquote", "code-block"], // 引用  代码块
  [{ header: 1 }, { header: 2 }], // 1、2 级标题
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  [{ script: "sub" }, { script: "super" }], // 上标/下标
  [{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}], // 文本方向
  [{ size: fontSize }], // 文字大小
  [{ font: fontFamily }], // 字体
  // [{ size: ["small", false, "large", "huge"] }],
  // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }], // 字体颜色、
  [{ background: [] }], // 字体背景颜色
  // [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  [{ align: [] }], // 对齐方式
  ["clean"] // 清除文本格式
  // ['link',"image",'upload'], // 链接、图片、视频
  // ["upload"],
  // // ['link']
  // ["sourceEditor"]  //附件
];
export default {
  name: "quillEditorPage",
  props: {
    editorContent: {
      type: String
    },
    pageSource: {
      type: String
    },
    fileList: {
      type: Array
    },
    type: {
      type: String
    }
  },
  components: { quillEditor },
  data() {
    return {
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/pp/oss/uploadFileToOssAndSave "
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      uploadData: {
        agentId: getArgs("a")
      },
      content: this.editorContent,
      // content: '我是富文本内容',
      info: null,
      // 工具栏配置
      editorOption: {
        theme: "snow",
        // bounds: document.body,
        modules: {
          toolbar: {
            container:
              this.pageSource == "postingAdd"
                ? toolbarOptions1
                : toolbarOptions,
            handlers: {
              upload: value => {
                if (value) {
                  document.querySelector(".my-upload").click();
                }
              },
              // link: (value) => {
              //   if (value) {
              //     document.querySelector('.uploadFile .el-icon-plus').click()
              //   }
              // }
              // image: function (value) {
              //   console.log(value, "value");
              //   if (value) {
              //     // 触发input框选择图片文件
              //     document
              //       .querySelector(".avatar-uploader-editor input")
              //       .click();
              //   } else {
              //     this.quill.format("image", false);
              //   }
              // },
              sourceEditor: function() {
                // 添加工具方法
                document.getElementsByClassName("my-upload")[0].click();
              }
            }
          }
        },
        placeholder: `
        1、这里发言，表示您接受了中交集团供应链管理信息系统的相关规定。
        2、请对您的言行负责,并遵守中华人民共和国有关法律法规和《互联网新闻信息服务管理规定》
        3、转载文章请注明出自原文出处。
        ` //提示
      },
      fileData: [],
      uploadLoading: false,
      quillUpdateImg: false
    };
  },
  created() {},
  activated() {
    console.log(this.type, "type");
    if (this.type == "Edit") {
      let params = {
        businessId: this.$route.query.themeId,
        isShowLoading: true
      };
      selectForumTheme(params).then(res => {
        if (res.data.code == "0") {
          this.fileData = [];
          res.data.data.tbasFileInfoBOList.forEach(item => {
            this.fileData.push({
              name: item.fileName,
              ...item
            });
          });
          console.log(this.fileData, "postingAdd");
        }
      });
    }
    // document.querySelector('.ql-editor').insertAdjacentHTML('beforebegin', '<div>这是更复杂的HTML结构</div>');
  },
  mounted() {
    addQuillTitle();
    // 上传附件的图标
    if (this.pageSource == "postingAdd") {
      this.$el.querySelector(
        ".ql-upload"
      ).innerHTML = `<svg t="1693300673548" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5709" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="200"><path d="M224 601.6v185.6a12.8 12.8 0 0 0 12.8 12.8h550.4a12.8 12.8 0 0 0 12.8-12.8V601.6a25.6 25.6 0 0 1 25.6-25.6h12.8a25.6 25.6 0 0 1 25.6 25.6v224a38.4 38.4 0 0 1-38.4 38.4H198.4a38.4 38.4 0 0 1-38.4-38.4v-224a25.6 25.6 0 0 1 25.6-25.6h12.8a25.6 25.6 0 0 1 25.6 25.6z m315.152-427.696l160 160a25.6 25.6 0 0 1 0 36.192l-9.056 9.056a25.6 25.6 0 0 1-36.192 0l-104.448-104.416a3.2 3.2 0 0 0-5.456 2.256V614.4a25.6 25.6 0 0 1-25.6 25.6h-12.8a25.6 25.6 0 0 1-25.6-25.6V276.992a3.2 3.2 0 0 0-5.456-2.256l-104.448 104.416a25.6 25.6 0 0 1-36.192 0l-9.056-9.056a25.6 25.6 0 0 1 0-36.192l160-160a38.4 38.4 0 0 1 54.304 0z" fill="#000000" p-id="5710"></path></svg>`;
    }
  },
  computed: {},
  watch: {},
  methods: {
    // openFile(e) {
    //   // 点击上传的文件列表的文件的操作
    //   console.log(e, "点击上传的文件列表的文件的操作");
    //   // window.open(e.url);
    //   var a = document.createElement("a");

    //   console.log(a, "创建a");

    //   var event = new MouseEvent("click");

    //   a.target = "_blank";
    //   a.download = e.name;
    //   a.href = e.url; //路径前拼上前缀，完整路径
    //   a.dispatchEvent(event);
    // },
    beforeAvatarUpload(file) {
      console.log(file);
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "LZH";
      if (!isLt50) {
        this.uploadLoading = false;
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      if (!extension) {
        this.uploadLoading = false;
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && extension;
    },
    handlePreview(file) {
      console.log(file, "file");
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/pp/oss/downloadByUploadId?uploadId=${file.uploadId}`;
      console.log(openUrl);
      openUrl.setAttribute("download", file.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    uploadSuccess(res, file, fileList) {
      this.$message.success("附件上传成功");
      this.uploadLoading = false;
      let fileData = res.data[0];
      this.fileData.push({
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        name: fileData.fileName,
        createTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId
      });
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: "上传出错，请联系管理员",
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading = false;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = true;
    },
    uploadBtn() {},
    // 失去焦点事件
    onEditorBlur(quill) {
      // console.log(quill,'失去焦点事件------');
    },
    // 获得焦点事件
    onEditorFocus(quill) {
      // console.log(quill,'获得焦点事件------');
    },
    // 内容改变事件
    onEditorChange({ quill, html, text }) {
      console.log(html, "内容改变事件------");
      // this.info = text.replace(/<\/?.+?\/?>|\r|\n|\s*/g, "");
      this.info = html;
      this.$emit("change", this.info);
    },
    // handleExceed() {
    //   // this.$message.warning('每次只能上传一个文件！')
    // },
    // 移除文件
    handleRemove(val) {
      console.log(val, this.fileData, "handleRemove");
      this.fileData.forEach((item, index) => {
        if (item.name == val.name) {
          this.fileData.splice(index, 1);
        }
      });
      // this.fileData = [];
    },

    handleSuccess(res, file) {
      this.fileData.push(file);
      // this.$refs.uploadRef.clearFiles(); // 上传成功之后清除历史记录
      this.uploadLoading.close();
      let fileData = res.data[0];
      let fileNameDuplication = false;
      if (this.fileData && this.fileData.length > 0) {
        this.fileData.forEach(item => {
          if (fileData.fileName == item.fileName) {
            fileNameDuplication = true;
          }
        });
      }
      if (fileNameDuplication) {
        this.$message({
          message: "请不要上传重名附件，请编辑后重新上传！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.uploadId) {
        this.$message({
          message: "上传ID不能为空！请重新上传文件！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.downloadUrl) {
        this.$message({
          message: "文件URL不能为空！请重新上传文件！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      // this.$message.success("附件上传成功！");
      this.$message.success({
        message: "附件上传成功！"

        // offset: document.body.clientHeight / 2 - 21
      });
    }
    // async uploadFileApi(file) {
    //   this.fileData.push(file.file);
    //   console.log(this.fileData, "file---------");

    //   let fromData = new FormData();
    //   fromData.append("file", file.file);
    //   await testApi
    //     .uploadLabel(fromData)
    //     .then(res => {
    //       // 根据实际需求请求接口
    //       if (res.code === 200) {
    //         this.$message.success(res.message);
    //         let fileNameLength = res.file.name.length;
    //         // 插入链接 获取富文本组件实例
    //         let quill = this.$refs.myQuillEditor.quill;
    //         let length = quill.getSelection().index;
    //         quill.insertEmbed(
    //           length,
    //           "link",
    //           { href: res.msg, innerText: res.file.name },
    //           "api"
    //         );
    //         // quill.insertEmbed(length, 'link', { href: res.data, innerText: file.name })
    //         quill.setSelection(length + fileNameLength);
    //         // this.fileData = []
    //       }
    //     })
    //     .catch(e => {
    //       this.$message.error(e.message);
    //     });
    // }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .ql-toolbar.ql-snow {
  border: none !important;
}
::v-deep .ql-container.ql-snow {
  border: none !important;
}
::v-deep .ql-upload {
  width: 90px !important;
}
::v-deep .ql-upload::before {
  content: "上传附件" !important;
}
::v-deep .editor {
  line-height: normal !important;
  height: 430px;
  .ql-editor {
    min-height: 100px !important;
    height: auto;
  }
}
::v-deep .ql-editor.ql-blank::before {
  font-style: normal;
  left: -12px;
  top: -5px;
  line-height: 19px;
}
.upload-demo {
  margin-top: 55px;
}

/deep/ .quill-editor {
  width: 100%;
  .ql-container {
    height: 300px;
  }
  .editor-upload {
    display: none;
  }
  /*
      文字大小
    */
  .ql-snow .ql-picker.ql-size {
    width: 70px; // 菜单栏占比宽度
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="10px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="10px"]::before {
    content: "10px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="12px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="12px"]::before {
    content: "12px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
    content: "14px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
    content: "16px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
    content: "20px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
    content: "24px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
    content: "36px";
  }

  /*
      字体
    */
  .ql-snow .ql-picker.ql-font {
    width: 80px; // 菜单栏占比宽度
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="宋体"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="宋体"]::before {
    content: "宋体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="黑体"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="黑体"]::before {
    content: "黑体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="微软雅黑"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="微软雅黑"]::before {
    content: "微软雅黑";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="楷体"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="楷体"]::before {
    content: "楷体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="仿宋"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="仿宋"]::before {
    content: "仿宋";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="Arial"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="Arial"]::before {
    content: "Arial";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="苹方"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="苹方"]::before {
    content: "苹方";
  }

  /*
      标题  
    */
  .ql-snow .ql-picker.ql-header {
    width: 80px; // 菜单栏占比宽度
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5" !important;
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6" !important;
  }
  //配置编辑器行高
  .ql-snow .ql-picker.ql-lineheight {
    width: 70px; // 菜单栏占比宽度
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
    content: "行高";
  }
  .ql-snow
    .ql-picker.ql-lineheight
    .ql-picker-item[data-value="initial"]::before {
    content: "默认";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1"]::before {
    content: "1";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1.5"]::before {
    content: "1.5";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1.75"]::before {
    content: "1.75";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="2"]::before {
    content: "2";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="3"]::before {
    content: "3";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="4"]::before {
    content: "4";
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="5"]::before {
    content: "5";
  }
}
</style>
